export default [
  { id: 'foodId', label: 'Food ID' },
  { id: 'date', label: 'Date' },
  { id: 'entered', label: 'Entered' },
  { id: 'type', label: 'Type' },
];